import Vue from 'vue';
import {request, setAuthInHeader} from "@/api/request";


Vue.prototype.$api = {
    $auth: { // 계정 로그인 / 회원가입 api
        login(params){ // 유저 로그인
            return request.memberPost("member/login", params).then(({data}) => data);
        },
    },
    $common: {
    },
    $member: {
        getMember(params) {
            return request.memberGet(`admin/member`, params).then(({data}) => data);
        },
        getFlyhighMember(params) {
            return request.get(`flyhigh/member/list`,params).then(({data}) => data);
        },
        updateMember(params) {
            return request.post(`admin/member/update`, params).then(({data}) => data);
        },
        updateMemberPwd(params) {
            return request.memberPost(`member/new/pwd`, params).then(({data}) => data);
        },
        checkPhone(params) {
            return request.memberGet(`member/chk/hp`, params).then(({data}) => data);
        },
        updatePhone(params) {
            return request.memberPost(`admin/member/update`, params).then(({data}) => data);
        },
        getQuitMember(params) {
            return request.memberGet(`member/out/list`, params).then(({data}) => data);
        },
        quitMember(params) {
            return request.memberPost(`member/delete`, params).then(({data}) => data);
        },
        getOutCategory(params) {
            return request.memberGet(`member/out/category`, params).then(({data}) => data);
        },
        getCafeMember(params) {
            return request.get(`cafe/member`, params).then(({data}) => data);
        },
        getProhibit(params) {
            return request.get(`prohibit/nick`, params).then(({data}) => data);
        },
        createProhibit(params) {
            return request.post(`prohibit/nick`, params).then(({data}) => data);
        },
        deleteProhibit(params) {
            return request.post(`prohibit/nick/delete`, params).then(({data}) => data);
        },
    },
    $board: {
        getNotice(params) {
            return request.get(`board/notice`, params).then(({data}) => data);
        },
        createNotice(params) {
            return request.post(`board/notice`, params).then(({data}) => data);
        },
        updateNotice(params) {
            return request.post(`board/notice/update`, params).then(({data}) => data);
        },
        deleteNotice(params) {
            return request.post(`board/notice/delete`, params).then(({data}) => data);
        },
        getFaq(params) {
            return request.get(`board/faq`, params).then(({data}) => data);
        },
        createFaq(params) {
            return request.post(`board/faq`, params).then(({data}) => data);
        },
        updateFaq(params) {
            return request.post(`board/faq/update`, params).then(({data}) => data);
        },
        deleteFaq(params) {
            return request.post(`board/faq/delete`, params).then(({data}) => data);
        },
        getRefund(params) {
            return request.get(`refund/board`, params).then(({data}) => data);
        },
        createRefundAnswer(params) {
            return request.post(`refund/board`, params).then(({data}) => data);
        },
        updateRefundAnswer(params) {
            return request.post(`refund/board/update`, params).then(({data}) => data);
        },
        getQa(params) {
            return request.get(`board/qna`, params).then(({data}) => data);
        },
        createQaAnswer(params) {
            return request.post(`board/qna/comment`, params).then(({data}) => data);
        },
        updateQaAnswer(params) {
            return request.post(`board/qna/comment/update`, params).then(({data}) => data);
        },

        getFeedback(params) {
            return request.get(`board/feedback`, params).then(({data}) => data);
        },
        createFeedbackAnswer(params) {
            return request.post(`board/feedback/comment`, params).then(({data}) => data);
        },
        updateFeedbackAnswer(params) {
            return request.post(`board/feedback/comment/update`, params).then(({data}) => data);
        },
        getCafeNotice(params) {
          return request.get('board/notice/cafe',params).then(({data}) => data)
        },
        deleteCafeNotice(params){
            return request.post('board/notice/cafe/delete',params).then(({data}) => data)
        },
        getCafeConfig(params){
            return request.get(`cafe/config`, params).then(({data}) => data);
        },
        updateCafeConfig(params){
            return request.post(`cafe/config/update`, params).then(({data}) => data);
        },
        getJstQna(params) {
            return request.get(`board/qna`, params).then(({data}) => data);
        },
        createJstQna(params) {
            return request.post(`board/qna/comment`, params).then(({data}) => data);
        },
        updateJstQna(params) {
            return request.post(`board/qna/comment/update`, params).then(({data}) => data);
        },
        getCategory(params) {
            return request.get(`board/faq/category`, params).then(({data}) => data);
        },
        getJstFaq(params) {
            return request.get(`board/faq`, params).then(({data}) => data);
        },
        createJstFaq(params) {
            return request.post(`board/faq`, params).then(({data}) => data);
        },
        updateJstFaq(params) {
            return request.post(`board/faq/update`, params).then(({data}) => data);
        },
        deleteJstFaq(params) {
            return request.post(`board/faq/delete`, params).then(({data}) => data);
        },
        createFaqCategory(params) {
            return request.post(`board/faq/category`, params).then(({data}) => data);
        },
        deleteFaqCategory(params) {
            return request.post(`board/faq/category/delete`, params).then(({data}) => data);
        },
        updateFaqCategory(params) {
            return request.post(`board/faq/category/update`, params).then(({data}) => data);
        },
        getJstMail(params){
            return request.get(`mail`, params).then(({data}) => data);
        },
        sendJstMail(params){
            return request.post(`mail`, params).then(({data}) => data);
        },
    },
    $config: {
        getCountry(params) {
            return request.get(`country`, params).then(({data}) => data);
        },
        getConfig(params) {
            return request.get(`config`, params).then(({data}) => data);
        },
        createConfig(params) {
            return request.post(`config`, params).then(({data}) => data);
        },
        updateConfig(params) {
            return request.post(`config/update`, params).then(({data}) => data);
        },
        deleteConfig(params) {
            return request.post(`config/delete`, params).then(({data}) => data);
        },
        getTerms(params){
            return request.get(`config`, params).then(({data}) => data);
        },
        updateTerms(params){
            return request.post(`config/update`, params).then(({data}) => data);
        },
    },
    $order: {
        getOrder(params) {
            return request.get(`order`, params).then(({data}) => data);
        }
    },
    $subscribe: {
        getSubscribe(params) {
            return request.get(`subscribe`, params).then(({data}) => data);
        },
        exitSubscribe(params) {
            return request.post(`subscribe/exit`, params).then(({data}) => data);
        },
    },
    $item: {
        getItem(params) {
            return request.get(`item`, params).then(({data}) => data);
        },
        createItem(params) {
            return request.post(`item`, params).then(({data}) => data);
        },
        updateItem(params) {
            return request.post(`item/update`, params).then(({data}) => data);
        },
        deleteItem(params) {
            return request.post(`item/delete`, params).then(({data}) => data);
        }
    },
    $popup:{
        getPopup(params) {
          return request.get(`event`, params).then(({data}) => data);
        },
        createPopup(params) {
            return request.post(`event`, params).then(({data}) => data);
        },
        updatePopup(params) {
            return request.post(`event/update`, params).then(({data}) => data);
        },
        deletePopup(params) {
            return request.post(`event/delete`, params).then(({data}) => data);
        },
    },
    $file: {
        editorUpload(params) {
            return request.post("file/editorUpload",params)
                .then(({data}) => data);
        },
        downLoad(params){
            return request.get(params)
                .then(({data}) => data);
        },
        updateFile(params) {
            return request.post(`file`, params).then(({data}) => data);
        },
        deleteFile(params) {
            return request.post("file/delete/"+params.a_idx)
                .then(({data}) => data);
        }
    },
    $cafe:{
        getCafe(params){
            return request.get(`cafe`, params).then(({data}) => data);
        },
        updateCafe(params){
            return request.post(`cafe/update`, params).then(({data}) => data);
        },
        deleteLeader(params){
            return request.post(`cafe/member/leader/out`, params).then(({data}) => data);
        },
        updateCafeAllow(params){
            return request.post(`cafe/allow`, params).then(({data}) => data);
        },
        getCafeMember(params){
            return request.get(`cafe/member`, params).then(({data}) => data);
        },
        deleteComment(params) {
            return request.post(`board/post/comment/delete`, params).then(({data}) => data);
        },

    },
    $post: {
        getPost(params) {
            return request.get(`board/post/just`, params).then(({data}) => data);
        },
        deletePost(params) {
            return request.post(`board/post/just/delete`, params).then(({data}) => data);
        },
        getPostComment(params) {
            return request.get(`board/post/comment`, params).then(({data}) => data);
        },
        deletePostComment(params) {
            return request.post(`board/post/comment/delete`, params).then(({data}) => data);
        },
        getLive(params) {
            return request.get(`board/live/just`, params).then(({data}) => data);
        },
        deleteLive(params) {
            return request.post(`board/live/just/delete`, params).then(({data}) => data);
        },
        downloadLive(params) {
            return request.post(`board/live/just/download`, params).then(({data}) => data);
        },
    },
    $declaration:{
        getDeclaration(params) {
            return request.get(`board/live/blind`, params).then(({data}) => data);
        },
    },
    $elastic: {
        createElastic(params) {
            return request.post(`search/elastic`, params).then(({data}) => data);
        },
        deleteElastic(params) {
            return request.post(`search/elastic/delete`, params).then(({data}) => data);
        },
    },
    $theme :{
        getTheme(params){
           return request.get(`theme`, params).then(({data}) => data);
        },
        createTheme(params){
            return request.post(`theme`, params).then(({data}) => data);
        },
        deleteTheme(params){
            return request.post(`theme/delete`, params).then(({data}) => data);
        },
        updateTheme(params){
            return request.post(`theme/update`, params).then(({data}) => data);
        },
    },
    $handler: {
        authHeader : setAuthInHeader
    }
};

export default Vue.prototype.$api;


